// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Customer profile'"></sub-header>
  <customer-profile-body profile="\$ctrl.profile">
    <buttons-when-edit-disabled class="summary-actions">
      <approval-action
        ng-if="\$ctrl.displayMode === 'OWNED'"
        level-label="Local override level"
        button-label="Local override"
        approval-action="\$ctrl.localOverrideAction"
        levels="\$ctrl.getLocalOverrideLevels(\$ctrl.task)"
        button-class="btn-primary action-button"
        task="\$ctrl.task"></approval-action>
      <approval-action
        ng-if="\$ctrl.displayMode != 'OWNED'"
        level-label="Approve level"
        button-label="Approve"
        approval-action="\$ctrl.approveAction"
        levels="\$ctrl.getApprovalLevels(\$ctrl.task)"
        task="\$ctrl.task"
        button-class="btn-success action-button"></approval-action>
      <button class="btn btn-danger action-button" type="button"
              ng-click="\$ctrl.displayMode === 'OWNED' ? \$ctrl.revoke() : \$ctrl.reject()">
        {{\$ctrl.displayMode === 'OWNED' ? 'Revoke' : 'Reject'}}
      </button>
    </buttons-when-edit-disabled>
  </customer-profile-body>

  <local-override task="\$ctrl.overrideTask"
                  on-pin-entered="\$ctrl.pinEntered(task, pin, user)">
  </local-override>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/profile/task/customer-profile-task-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;